"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "modena": {
    "015d3017": [{
      "hkey": "f1bda499",
      "slug": "crocetta-san-lazzaro-sacca-musicisti",
      "name": "Crocetta, San Lazzaro, Sacca, Musicisti",
      "primary": true,
      "skipSearch": false
    }],
    "0329b2ea": [{
      "hkey": "4a44ba8c",
      "slug": "buon-pastore-sant-agnese",
      "name": "Buon Pastore, Sant'Agnese",
      "primary": true,
      "skipSearch": false
    }],
    "05c24f79": [{
      "hkey": "f1bda499",
      "slug": "crocetta-san-lazzaro-sacca-musicisti",
      "name": "Crocetta, San Lazzaro, Sacca, Musicisti",
      "primary": true,
      "skipSearch": false
    }],
    "06aefcc5": [{
      "hkey": "20d85f23",
      "slug": "san-faustino-villaggio-giardino",
      "name": "San Faustino, Villaggio Giardino",
      "primary": true,
      "skipSearch": false
    }],
    "06e44e9e": [{
      "hkey": "f1bda499",
      "slug": "crocetta-san-lazzaro-sacca-musicisti",
      "name": "Crocetta, San Lazzaro, Sacca, Musicisti",
      "primary": true,
      "skipSearch": false
    }],
    "1bbf7d86": [{
      "hkey": "7d554376",
      "slug": "madonnina-san-cataldo-tre-olmi-villaggio-artigiano",
      "name": "Madonnina, San Cataldo, Tre Olmi, Villaggio Artigiano",
      "primary": true,
      "skipSearch": false
    }],
    "1c88d894": [{
      "hkey": "7d554376",
      "slug": "madonnina-san-cataldo-tre-olmi-villaggio-artigiano",
      "name": "Madonnina, San Cataldo, Tre Olmi, Villaggio Artigiano",
      "primary": true,
      "skipSearch": false
    }],
    "26f06cf1": [{
      "hkey": "ba032548",
      "slug": "fossalta-san-damaso",
      "name": "Fossalta, San Damaso",
      "primary": true,
      "skipSearch": false
    }],
    "2af4e130": [{
      "hkey": "b2af432d",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "skipSearch": false
    }],
    "2c73e043": [{
      "hkey": "bc8c210c",
      "slug": "lesignana-san-pancrazio-villanova",
      "name": "Lesignana, San Pancrazio, Villanova",
      "primary": true,
      "skipSearch": false
    }],
    "2d8dfda0": [{
      "hkey": "c57b00c7",
      "slug": "navicello-torrazzi-saliceto-panaro-modena-est",
      "name": "Navicello, Torrazzi-Saliceto Panaro, Modena Est",
      "primary": true,
      "skipSearch": false
    }],
    "348a1032": [{
      "hkey": "f1bda499",
      "slug": "crocetta-san-lazzaro-sacca-musicisti",
      "name": "Crocetta, San Lazzaro, Sacca, Musicisti",
      "primary": true,
      "skipSearch": false
    }],
    "3e043244": [{
      "hkey": "20d85f23",
      "slug": "san-faustino-villaggio-giardino",
      "name": "San Faustino, Villaggio Giardino",
      "primary": true,
      "skipSearch": false
    }],
    "3e5879b4": [{
      "hkey": "c57b00c7",
      "slug": "navicello-torrazzi-saliceto-panaro-modena-est",
      "name": "Navicello, Torrazzi-Saliceto Panaro, Modena Est",
      "primary": true,
      "skipSearch": false
    }],
    "4522d2b8": [{
      "hkey": "7d554376",
      "slug": "madonnina-san-cataldo-tre-olmi-villaggio-artigiano",
      "name": "Madonnina, San Cataldo, Tre Olmi, Villaggio Artigiano",
      "primary": true,
      "skipSearch": false
    }],
    "460b96d0": [{
      "hkey": "dcd42d35",
      "slug": "portile-san-donnino",
      "name": "Portile, San Donnino",
      "primary": true,
      "skipSearch": false
    }],
    "4d10985f": [{
      "hkey": "bc8c210c",
      "slug": "lesignana-san-pancrazio-villanova",
      "name": "Lesignana, San Pancrazio, Villanova",
      "primary": true,
      "skipSearch": false
    }],
    "56ddedcf": [{
      "hkey": "a3bf8cdf",
      "slug": "cittanova-marzaglia",
      "name": "Cittanova, Marzaglia",
      "primary": true,
      "skipSearch": false
    }],
    "5a24aced": [{
      "hkey": "bc8c210c",
      "slug": "lesignana-san-pancrazio-villanova",
      "name": "Lesignana, San Pancrazio, Villanova",
      "primary": true,
      "skipSearch": false
    }],
    "5d096d02": [{
      "hkey": "bc8c210c",
      "slug": "lesignana-san-pancrazio-villanova",
      "name": "Lesignana, San Pancrazio, Villanova",
      "primary": true,
      "skipSearch": false
    }],
    "6091524f": [{
      "hkey": "68fc04bb",
      "slug": "cognento-saliceta-san-giuliano-villaggio-zeta",
      "name": "Cognento, Saliceta San Giuliano-Villaggio Zeta",
      "primary": true,
      "skipSearch": false
    }],
    "6a473e7e": [{
      "hkey": "fb932a2a",
      "slug": "albareto-san-matteo",
      "name": "Albareto, San Matteo",
      "primary": true,
      "skipSearch": false
    }],
    "6f062855": [{
      "hkey": "dcd42d35",
      "slug": "portile-san-donnino",
      "name": "Portile, San Donnino",
      "primary": true,
      "skipSearch": false
    }],
    "728c6cc0": [{
      "hkey": "68fc04bb",
      "slug": "cognento-saliceta-san-giuliano-villaggio-zeta",
      "name": "Cognento, Saliceta San Giuliano-Villaggio Zeta",
      "primary": true,
      "skipSearch": false
    }],
    "7827fc80": [{
      "hkey": "b2af432d",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "skipSearch": false
    }],
    "791a080d": [{
      "hkey": "7d554376",
      "slug": "madonnina-san-cataldo-tre-olmi-villaggio-artigiano",
      "name": "Madonnina, San Cataldo, Tre Olmi, Villaggio Artigiano",
      "primary": true,
      "skipSearch": false
    }],
    "89b5e2ae": [{
      "hkey": "b2af432d",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "skipSearch": false
    }],
    "9130351e": [{
      "hkey": "f1bda499",
      "slug": "crocetta-san-lazzaro-sacca-musicisti",
      "name": "Crocetta, San Lazzaro, Sacca, Musicisti",
      "primary": true,
      "skipSearch": false
    }],
    "9b905bc5": [{
      "hkey": "4a44ba8c",
      "slug": "buon-pastore-sant-agnese",
      "name": "Buon Pastore, Sant'Agnese",
      "primary": true,
      "skipSearch": false
    }],
    "adb58d93": [{
      "hkey": "ba032548",
      "slug": "fossalta-san-damaso",
      "name": "Fossalta, San Damaso",
      "primary": true,
      "skipSearch": false
    }],
    "albareto": [{
      "hkey": "fb932a2a",
      "slug": "albareto-san-matteo",
      "name": "Albareto, San Matteo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "b0303840": [{
      "hkey": "4a44ba8c",
      "slug": "buon-pastore-sant-agnese",
      "name": "Buon Pastore, Sant'Agnese",
      "primary": true,
      "skipSearch": false
    }],
    "b5c6836b": [{
      "hkey": "7d554376",
      "slug": "madonnina-san-cataldo-tre-olmi-villaggio-artigiano",
      "name": "Madonnina, San Cataldo, Tre Olmi, Villaggio Artigiano",
      "primary": true,
      "skipSearch": false
    }],
    "bc66dd1d": [{
      "hkey": "c57b00c7",
      "slug": "navicello-torrazzi-saliceto-panaro-modena-est",
      "name": "Navicello, Torrazzi-Saliceto Panaro, Modena Est",
      "primary": true,
      "skipSearch": false
    }],
    "buon-pastore": [{
      "hkey": "4a44ba8c",
      "slug": "buon-pastore-sant-agnese",
      "name": "Buon Pastore, Sant'Agnese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "cittadella": [{
      "hkey": "7d554376",
      "slug": "madonnina-san-cataldo-tre-olmi-villaggio-artigiano",
      "name": "Madonnina, San Cataldo, Tre Olmi, Villaggio Artigiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "cittanova": [{
      "hkey": "a3bf8cdf",
      "slug": "cittanova-marzaglia",
      "name": "Cittanova, Marzaglia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "cognento": [{
      "hkey": "68fc04bb",
      "slug": "cognento-saliceta-san-giuliano-villaggio-zeta",
      "name": "Cognento, Saliceta San Giuliano-Villaggio Zeta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "collegara": [{
      "hkey": "ba032548",
      "slug": "fossalta-san-damaso",
      "name": "Fossalta, San Damaso",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "crocetta": [{
      "hkey": "f1bda499",
      "slug": "crocetta-san-lazzaro-sacca-musicisti",
      "name": "Crocetta, San Lazzaro, Sacca, Musicisti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "d519c0b3": [{
      "hkey": "b2af432d",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "skipSearch": false
    }],
    "direzionale-70": [{
      "hkey": "20d85f23",
      "slug": "san-faustino-villaggio-giardino",
      "name": "San Faustino, Villaggio Giardino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "ex-autodromo": [{
      "hkey": "7d554376",
      "slug": "madonnina-san-cataldo-tre-olmi-villaggio-artigiano",
      "name": "Madonnina, San Cataldo, Tre Olmi, Villaggio Artigiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "f4c08f6c": [{
      "hkey": "4a44ba8c",
      "slug": "buon-pastore-sant-agnese",
      "name": "Buon Pastore, Sant'Agnese",
      "primary": true,
      "skipSearch": false
    }],
    "f63b7b5d": [{
      "hkey": "a3bf8cdf",
      "slug": "cittanova-marzaglia",
      "name": "Cittanova, Marzaglia",
      "primary": true,
      "skipSearch": false
    }],
    "ganaceto": [{
      "hkey": "bc8c210c",
      "slug": "lesignana-san-pancrazio-villanova",
      "name": "Lesignana, San Pancrazio, Villanova",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "lesignana": [{
      "hkey": "bc8c210c",
      "slug": "lesignana-san-pancrazio-villanova",
      "name": "Lesignana, San Pancrazio, Villanova",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "madonnina": [{
      "hkey": "7d554376",
      "slug": "madonnina-san-cataldo-tre-olmi-villaggio-artigiano",
      "name": "Madonnina, San Cataldo, Tre Olmi, Villaggio Artigiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "marzaglia": [{
      "hkey": "a3bf8cdf",
      "slug": "cittanova-marzaglia",
      "name": "Cittanova, Marzaglia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "modena-est": [{
      "hkey": "c57b00c7",
      "slug": "navicello-torrazzi-saliceto-panaro-modena-est",
      "name": "Navicello, Torrazzi-Saliceto Panaro, Modena Est",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "morane": [{
      "hkey": "4a44ba8c",
      "slug": "buon-pastore-sant-agnese",
      "name": "Buon Pastore, Sant'Agnese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "navicello": [{
      "hkey": "c57b00c7",
      "slug": "navicello-torrazzi-saliceto-panaro-modena-est",
      "name": "Navicello, Torrazzi-Saliceto Panaro, Modena Est",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "portile": [{
      "hkey": "dcd42d35",
      "slug": "portile-san-donnino",
      "name": "Portile, San Donnino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }, {
      "hkey": "5dbce66d",
      "slug": "portile-paganine",
      "name": "Portile-Paganine",
      "primary": true,
      "levelFrom": 11,
      "levelTo": 11,
      "slugLevelParent": null
    }],
    "prossimita-centro": [{
      "hkey": "b2af432d",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "sacca": [{
      "hkey": "f1bda499",
      "slug": "crocetta-san-lazzaro-sacca-musicisti",
      "name": "Crocetta, San Lazzaro, Sacca, Musicisti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "san-damaso": [{
      "hkey": "ba032548",
      "slug": "fossalta-san-damaso",
      "name": "Fossalta, San Damaso",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "san-donnino": [{
      "hkey": "dcd42d35",
      "slug": "portile-san-donnino",
      "name": "Portile, San Donnino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "san-lazzaro": [{
      "hkey": "f1bda499",
      "slug": "crocetta-san-lazzaro-sacca-musicisti",
      "name": "Crocetta, San Lazzaro, Sacca, Musicisti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "sant-agnese": [{
      "hkey": "4a44ba8c",
      "slug": "buon-pastore-sant-agnese",
      "name": "Buon Pastore, Sant'Agnese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "stazione-treni": [{
      "hkey": "b2af432d",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "torrazzi": [{
      "hkey": "c57b00c7",
      "slug": "navicello-torrazzi-saliceto-panaro-modena-est",
      "name": "Navicello, Torrazzi-Saliceto Panaro, Modena Est",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "tre-olmi": [{
      "hkey": "bc8c210c",
      "slug": "lesignana-san-pancrazio-villanova",
      "name": "Lesignana, San Pancrazio, Villanova",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "via-giardini": [{
      "hkey": "4a44ba8c",
      "slug": "buon-pastore-sant-agnese",
      "name": "Buon Pastore, Sant'Agnese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "viale-storchi": [{
      "hkey": "b2af432d",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "villaggio-artigiano-modena-nord": [{
      "hkey": "f1bda499",
      "slug": "crocetta-san-lazzaro-sacca-musicisti",
      "name": "Crocetta, San Lazzaro, Sacca, Musicisti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "villaggio-artigiano-modena-ovest": [{
      "hkey": "7d554376",
      "slug": "madonnina-san-cataldo-tre-olmi-villaggio-artigiano",
      "name": "Madonnina, San Cataldo, Tre Olmi, Villaggio Artigiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "villaggio-artigiano-zona-panini": [{
      "hkey": "7d554376",
      "slug": "madonnina-san-cataldo-tre-olmi-villaggio-artigiano",
      "name": "Madonnina, San Cataldo, Tre Olmi, Villaggio Artigiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "villaggio-giardino": [{
      "hkey": "20d85f23",
      "slug": "san-faustino-villaggio-giardino",
      "name": "San Faustino, Villaggio Giardino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "villaggio-zeta": [{
      "hkey": "68fc04bb",
      "slug": "cognento-saliceta-san-giuliano-villaggio-zeta",
      "name": "Cognento, Saliceta San Giuliano-Villaggio Zeta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "villanova": [{
      "hkey": "bc8c210c",
      "slug": "lesignana-san-pancrazio-villanova",
      "name": "Lesignana, San Pancrazio, Villanova",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "zona-viali": [{
      "hkey": "b2af432d",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "b296f137": [{
      "hkey": "20d85f23",
      "slug": "san-faustino-villaggio-giardino",
      "name": "San Faustino, Villaggio Giardino",
      "primary": true,
      "skipSearch": false
    }],
    "san-faustino": [{
      "hkey": "20d85f23",
      "slug": "san-faustino-villaggio-giardino",
      "name": "San Faustino, Villaggio Giardino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "09de90bf": [{
      "hkey": "5dbce66d",
      "slug": "portile-paganine",
      "name": "Portile-Paganine",
      "primary": true,
      "skipSearch": false
    }],
    "paganine": [{
      "hkey": "5dbce66d",
      "slug": "portile-paganine",
      "name": "Portile-Paganine",
      "primary": true,
      "levelFrom": 11,
      "levelTo": 11,
      "slugLevelParent": "portile-san-donnino"
    }],
    "428f00de": [{
      "hkey": "5dbce66d",
      "slug": "portile-paganine",
      "name": "Portile-Paganine",
      "primary": true,
      "skipSearch": false
    }],
    "af4bcfc2": [{
      "hkey": "22d18b96",
      "slug": "santa-maria-san-martino-mugnano",
      "name": "Santa Maria-San Martino Mugnano",
      "primary": true,
      "skipSearch": false
    }],
    "san-martino-mugnano": [{
      "hkey": "22d18b96",
      "slug": "santa-maria-san-martino-mugnano",
      "name": "Santa Maria-San Martino Mugnano",
      "primary": true,
      "levelFrom": 11,
      "levelTo": 11,
      "slugLevelParent": "portile-san-donnino"
    }],
    "98c44d5a": [{
      "hkey": "22d18b96",
      "slug": "santa-maria-san-martino-mugnano",
      "name": "Santa Maria-San Martino Mugnano",
      "primary": true,
      "skipSearch": false
    }],
    "santa-maria-mugnano": [{
      "hkey": "22d18b96",
      "slug": "santa-maria-san-martino-mugnano",
      "name": "Santa Maria-San Martino Mugnano",
      "primary": true,
      "levelFrom": 11,
      "levelTo": 11,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;